import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeroImg from '../assets/exam_prep.jpg';
import '../styles/Hero.css';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const heroButtons = [
    { to: '/premium', label: 'Premium', icon: '⭐', variant: 'premium' },
    { to: '/subjects', label: 'Test Series', icon: '📝', variant: 'primary' }, // Changed from /allquizes
    { to: '/articles', label: `Current Affairs ${new Date().getFullYear()}`, icon: '📰', variant: 'info' },
    { to: '/ebooks', label: 'Study Material', icon: '📚', variant: 'success' },
    { to: '/latest-updates', label: 'Latest Updates', icon: '🔔', variant: 'warning' }
  ];

  return (
    <div className={`hero-section ${isVisible ? 'visible' : ''}`}>
      <div className="container-fluid">
        <div className="row align-items-center g-4">
          {/* Hero Image */}
          <div className="col-lg-6 col-md-12">
            <div className="hero-img-container">
              <div className="image-wrapper">
                <img 
                  src={HeroImg} 
                  className="hero-image" 
                  alt="Exam Preparation Illustration" 
                  loading="eager"
                />
                <div className="image-overlay"></div>
              </div>
            </div>
          </div>

          {/* Hero Content */}
          <div className="col-lg-6 col-md-12">
            <div className="hero-content-container">
              <div className="hero-content">
                <h1 className="hero-title">
                  Test Series and Daily Current Affairs{' '}
                  <span className="hero-highlight">By Spardhaweb</span>
                </h1>
                <p className="hero-description">
                  Access daily quizzes covering various topics and stay updated with 
                  one-liner current affairs in Marathi. We provide tailored resources 
                  to enhance your preparation, ensuring you're equipped with the 
                  knowledge and confidence to ace the exam. Start your journey to 
                  success today!
                </p>
              </div>

              {/* Hero Buttons */}
              <div className="hero-buttons">
                {heroButtons.map((button, index) => (
                  <Link
                    key={button.to}
                    className={`hero-btn hero-btn-${button.variant}`}
                    to={button.to}
                    role="button"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <span className="btn-icon">{button.icon}</span>
                    <span className="btn-text">{button.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="hero-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </div>
  );
}